.panelContent {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: var(--spacer-5);
  padding: var(--spacer-5);
}

.empty {
  text-align: center;
  font-size: var(--font-size-100);
  color: var(--theme-tertiary-text);
  border-radius: var(--Common--border-radius);
  background: var(--theme-container-background);
  padding: var(--spacer-6) var(--spacer-2);

  & p {
    margin: var(--spacer-1) 0;
  }
  & a {
    cursor: pointer;
  }
}

.smartZoneTitleContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5em;
}

.smartZoneTitle {
  margin: 0;
  position: relative;
}

.smartZoneTitle > div {
  outline: none;
  padding-right: 20px;
}
.smartZoneTitle > i {
  visibility: hidden;
  font-size: var(--default-font-size);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  margin: 4px 0;
  pointer-events: none;
}
.smartZoneTitle:hover > i {
  visibility: visible;
}
.smartZoneTitle > div:focus + i {
  visibility: hidden;
}

.smartZonesHeader {
  padding: var(--spacer-2) 0 var(--spacer-5);
}

.smartZoneItem {
  padding: var(--spacer-2);
  margin: 0 calc(0px - var(--spacer-2));
  display: block;
  color: var(--theme-primary-text);
  cursor: pointer;
}
.smartZoneItem:hover {
  background: var(--theme-secondary-background);
  text-decoration: none;
}

/* SmartZoneEditor styles */
.container {
  display: flex;
  flex-direction: column;
  gap: var(--spacer-2);
  padding: var(--spacer-4) 0;
}

.recordTypeSection {
  display: flex;
  flex-direction: column;
  gap: var(--spacer-4);
  padding-bottom: var(--spacer-6);
  margin-bottom: var(--spacer-2);
  border-bottom: 1px solid var(--theme-light-border);
}

.recordTypeHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.recordTypeName {
  font-size: var(--font-size-100);
  font-weight: 600;
  color: var(--theme-text);
  margin: 0;
}

.fieldRow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.fieldLabel {
  font-size: var(--font-size-200);
  color: var(--theme-secondary-text);
  width: 12em;
}

.fieldInputWrapper {
  flex: 1;
}

.fieldInput {
  width: 100%;
  padding: var(--spacer-3);
  border: 1px solid var(--theme-border);
  border-radius: var(--Common--border-radius);
  font-size: var(--font-size-200);
  background-color: var(--theme-input-background);
}

.addRecordTypeWrapper {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  margin-top: var(--spacer-2);
}

.addZoneWrapper {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  margin-top: var(--spacer-2);
}

.rotate {
  animation: rotate 2s linear infinite;
  transform-origin: center;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.smartZoneFooterContainer {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}
